import { graphql } from "../graphql";

export const GetOnCourseDeviceAppDataQuery = graphql(/* GraphQL */ `
  query getOnCourseDeviceAppData {
    applicationData(client: ON_COURSE_KIOSK_APP) {
      ... on OnCourseKioskDeviceData {
        __typename
        device {
          id
          name
          course {
            id
            displayName
            description
            onCourseConfig {
              autoConsent
            }
            location {
              id
              name
              timezone
              address {
                city
                countryCode
                stateCode
              }
            }
          }
          hole {
            holeNumber
            name
            description
            tees {
              name
              par
              distance
            }
          }
          radars {
            id
            serialNumber
            name
            url
          }
        }
      }
    }
  }
`);
